import { Component, OnDestroy, OnInit } from '@angular/core';
import { Event } from '@app/entity';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from '@app/core/services';
import * as moment from 'moment';
import { animations } from '@app/magazine/magazine-events/magazine-events.animations';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { forceRedirectTo } from '@app/shared/utils';

@Component({
  selector: 'app-magazine-events',
  animations: animations,
  templateUrl: './magazine-events.component.html',
  styleUrls: ['./magazine-events.component.scss']
})
export class MagazineEventsComponent implements OnInit, OnDestroy {
  events: Event[] = [];
  isLoading = false;
  eventsNext: string;
  filter = {};
  calendarEvents = {};
  currentDate = moment();

  ngUnsubscribe = new Subject();

  isFirstLoad = true;

  constructor(
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(params => {
        this.filter = {...this.filter, city: params['city']};
        if (this.filter['city'] && (!this.filter['date_0'] || !this.filter['date_0'])) this.isFirstLoad = true;
        this.getEvents(this.eventsNext, params);
        this.onMonthChange(this.currentDate);
        this.isFirstLoad = false;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getEvents(nextUrl?: string, filter?: any) {
    if (this.isFirstLoad) {
      filter = {
        ...filter,
        date_0: moment().format('YYYY-MM-DD'),
        // date_1: moment().add(1, 'months').format('YYYY-MM-DD'),
      };
    }

    if (this.isLoading) return;
    this.isLoading = true;
    this.eventsService.list(nextUrl, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .finally(() => this.isLoading = false)
      .subscribe(response => {
        this.events =  filter ? response.results : this.events.concat(response.results);
        this.eventsNext = response.next;
      });
  }

  onScroll() {
    if (!this.eventsNext) return;
    this.getEvents(this.eventsNext);
    this.eventsNext = null;
  }

  onDateSelect(date_range) {
    const date_filter = {
      date_0: date_range.start.format('YYYY-MM-DD'),
      // date_1: date_range.end.format('YYYY-MM-DD'),
    };

    this.filter = {...this.filter, ...date_filter};
    this.router.navigate([], {
      queryParams: this.filter,
      relativeTo: this.route
    });
  }

  onMonthChange(date: moment.Moment) {
    const start = moment(date).startOf('month');
    const end = moment(date).endOf('month');
    const date_filter = {
      date_0: start.format('YYYY-MM-DD'),
      date_1: end.format('YYYY-MM-DD'),
    };
    this.getEvents(this.eventsNext, {date_0: date_filter.date_0});
    this.currentDate = date;
    const filter = {...this.filter, ...date_filter};
    this.eventsService.calendar(filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(calendar => {
        this.calendarEvents = calendar;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/magazine/magazine-events/magazine-events.component.ts